import { QUERY_KEYS } from "@/libraries/constant";
import type {
	CreatePatientPayloadSchema,
	UpdatePatientPayloadSchema,
} from "@/schemas";
import type {
	GetPatientCaseResponse,
	PostCreatePatientResponse,
	ResError,
} from "@/types";
import { useMutation } from "@tanstack/react-query";
import type { PatchUpdatePatientResponse, Patient } from "../types/patient";

function usePatientMutation() {
	const create = useMutation<
		PostCreatePatientResponse,
		ResError,
		CreatePatientPayloadSchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_PATIENT_CREATE],
	});

	const update = useMutation<
		PatchUpdatePatientResponse,
		ResError,
		UpdatePatientPayloadSchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_PATIENT_UPDATE],
	});

	const check = useMutation<
		GetPatientCaseResponse,
		ResError,
		Patient["ic_number"]
	>({
		mutationKey: [QUERY_KEYS.MUTATE_CHECK_PATIENT_IN_CASE],
	});

	return { create, update, check };
}

export default usePatientMutation;
